import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import counterReducer from './slices/counter/counterSlice';
import customizerReducer from './slices/customizer/customizerSlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    customizer: customizerReducer
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
